// extracted by mini-css-extract-plugin
export default {"botao":"ModalButton_botao__x6FtG"};